declare const Phaser: any;

import { BaseScene } from "../../framework/BaseScene";
import { RunState } from "../data/RunState";

export class RestScene extends BaseScene {
  private run!: RunState;

  constructor() {
    super({ key: "RestScene" });
  }

  onReady(_data?: any): void {
    this.run = this.game.registry.get("runState");
    const healAmount = Math.floor(this.run.player.maxHp * 0.3);

    this.add.rectangle(400, 225, 800, 450, 0x0f1f0f);

    this.add.text(400, 60, "REST", {
      fontFamily: "system-ui, sans-serif",
      fontSize: "32px",
      color: "#22c55e",
      fontStyle: "bold",
    }).setOrigin(0.5);

    // Campfire
    this.add.circle(400, 200, 6, 0xf97316);
    this.add.circle(395, 195, 4, 0xfbbf24);
    this.add.circle(405, 198, 3, 0xef4444);

    this.add.text(400, 250, `HP: ${this.run.player.hp}/${this.run.player.maxHp}`, {
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      color: "#d1d5db",
    }).setOrigin(0.5);

    // Rest button
    const btn = this.add.rectangle(400, 320, 180, 40, 0x166534);
    btn.setStrokeStyle(2, 0x22c55e);
    btn.setInteractive({ useHandCursor: true });
    this.add.text(400, 320, `REST (+${healAmount} HP)`, {
      fontFamily: "system-ui, sans-serif",
      fontSize: "14px",
      color: "#ffffff",
      fontStyle: "bold",
    }).setOrigin(0.5);

    btn.on("pointerdown", () => {
      this.sm.pop({ outcome: "rested", hpChange: healAmount });
    });
  }

  onUpdate(_time: number, _delta: number): void {}
}
